import { ArrowRight, History, Package, Sparkles, TrendingDown, TrendingUp, Truck } from "lucide-react";
import { Button } from "../ui/button";

const formatPrice = (value) => `€ ${Number(value || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 4 })}`;
const formatDate = (value) => value ? new Date(`${value}T12:00:00`).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "2-digit" }) : "—";

const PricePoint = ({ label, point, testId }) => (
  <div className="min-w-0" data-testid={testId}>
    <p className="text-[10px] font-bold uppercase text-muted-foreground">{label}</p>
    <p className="mt-1 text-lg font-extrabold text-foreground">{formatPrice(point.prezzo)}</p>
    <p className="mt-0.5 truncate text-xs font-semibold text-foreground">{point.fornitore_nome}</p>
    <p className="text-[11px] text-muted-foreground">{formatDate(point.data)}</p>
  </div>
);

export const PriceAnalysisCard = ({ item, onHistory }) => {
  const increasing = item.trend === "aumento";
  const TrendIcon = increasing ? TrendingUp : TrendingDown;
  const trendClasses = increasing
    ? "border-red-200 bg-red-50 text-red-700"
    : "border-emerald-200 bg-emerald-50 text-emerald-700";

  return (
    <article
      className="rounded-lg border border-border bg-card p-3 shadow-sm transition-[transform,box-shadow] duration-200 sm:hover:-translate-y-0.5 sm:hover:shadow-md"
      data-testid={`price-analysis-card-${item.id}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-1.5">
            <Package className={`h-4 w-4 shrink-0 ${item.tipo === "food" ? "text-indigo-600" : "text-amber-600"}`} />
            <h2 className="truncate text-base font-extrabold text-foreground" data-testid={`price-analysis-name-${item.id}`}>{item.nome}</h2>
          </div>
          <span className="mt-1 inline-flex rounded-full border border-border px-2 py-0.5 text-[10px] font-bold text-muted-foreground">
            {item.tipo === "food" ? "Food & Beverage" : "Packaging & Materiali"}
          </span>
        </div>
        <div className={`shrink-0 rounded-lg border px-2.5 py-2 text-right ${trendClasses}`} data-testid={`price-analysis-delta-${item.id}`}>
          <div className="flex items-center justify-end gap-1 text-sm font-extrabold">
            <TrendIcon className="h-4 w-4" />
            {item.variazione_percentuale > 0 ? "+" : ""}{item.variazione_percentuale.toFixed(1)}%
          </div>
          <p className="mt-0.5 text-[11px] font-bold">
            {item.variazione_euro > 0 ? "+" : ""}{formatPrice(item.variazione_euro)}
          </p>
        </div>
      </div>

      <div className="mt-3 grid grid-cols-[1fr_auto_1fr] items-center gap-2 border-t border-border pt-3">
        <PricePoint label="Inizio periodo" point={item.iniziale} testId={`price-analysis-start-${item.id}`} />
        <ArrowRight className="h-4 w-4 text-muted-foreground" />
        <PricePoint label="Prezzo attuale" point={item.attuale} testId={`price-analysis-current-${item.id}`} />
      </div>

      {item.alternativa && (
        <div className="mt-3 flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 p-2.5" data-testid={`price-analysis-alternative-${item.id}`}>
          <Sparkles className="h-4 w-4 shrink-0 text-amber-700" />
          <div className="min-w-0 flex-1">
            <p className="text-[10px] font-bold uppercase text-amber-800">Puoi risparmiare {formatPrice(item.alternativa.risparmio_euro)}/{item.unita_misura}</p>
            <p className="truncate text-xs font-bold text-amber-950">
              {item.alternativa.fornitore_nome} · {formatPrice(item.alternativa.prezzo)}
            </p>
          </div>
          <Truck className="h-4 w-4 shrink-0 text-amber-700" />
        </div>
      )}

      <Button
        variant="ghost"
        onClick={() => onHistory(item)}
        className="mt-2 h-11 w-full justify-between px-2 text-xs font-bold"
        data-testid={`price-analysis-history-${item.id}`}
      >
        <span className="flex items-center gap-1.5"><History className="h-4 w-4" />Apri storico prezzi</span>
        <ArrowRight className="h-4 w-4" />
      </Button>
    </article>
  );
};